export default __webpack_public_path__ + "static/media/3.93cc5ded.png";